import React from 'react';

import { useQuery } from '@apollo/client/react';
import { MainView } from '@repo/ui/Views';
import { Authorization, POLICIES } from '@/lib/Authorization';
import { useUser } from '@repo/hooks/useUser';
import { FallbackCard } from '@repo/ui/Card';

import DIDS_SHOW_Q from '../gql/show.gql';
import DidTabNav from '../components/DidTabNav';

import SwitchForwardingSummary from '../components/SwitchForwardingSummary';
import { useAccount } from '@/hooks/useAccount';
import { useParams } from 'react-router';

const DidForwards = () => {
  const user = useUser();

  const params = useParams();
  const didId = params.didId;

  const account = useAccount();

  const { loading, data } = useQuery(DIDS_SHOW_Q, {
    variables: {
      id: String(didId),
    },
  });

  return (
    <MainView title={loading ? `Loading...` : `${data?.did?.number}`} loading={loading}>
      <DidTabNav />
      <Authorization
        policyCheck={POLICIES['switches:index'](user)}
        fallbackView={
          <FallbackCard
            title="No access"
            description="You do not have the permissions to view message forwards."
          />
        }
      >
        {data?.did && (
          <SwitchForwardingSummary
            accountId={account.id}
            didId={data.did.id}
            didSwitch={data.did.switch}
            canEdit={POLICIES['switches:update'](user)}
            canChangeSwitch={POLICIES['dids:update'](user)}
          />
        )}
      </Authorization>
    </MainView>
  );
};

export default DidForwards;
